import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    personListRest: []
};

const getters = {
    getPersonPodr: state => state.personListRest
};

const actions = {
    getPersonPodr({commit}) {
        axiosGet(`crm/persons?podr`).then(({data}) => {
            commit('PERSON_INFO', data)
        }).catch((error) => console.log(error));
    },
};

const mutations = {
    PERSON_INFO(state, data) {
        state.personListRest = data;
    }
};


export default {
    state,
    getters,
    actions,
    mutations
}
